<ng-container *ngIf="state$ | async as state">

  <!-- LOADING: white card loader covering the whole dialog -->
  <div class="pv-dialog-loading" *ngIf="state.status === Status.LOADING; else readyTpl">
      <pv-spinner message="Loading options…" fill="white"></pv-spinner>
  </div>

  <ng-template #readyTpl>

    <h2 mat-dialog-title class="pv-dialog-title">
        <mat-icon class="material-symbols-outlined">timeline</mat-icon>
        <span class="pv-dialog-title-text">Gantt Chart Options</span>
        <button mat-icon-button class="pv-dialog-close" (click)="cancel()" matTooltip="Close" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <mat-dialog-content class="pv-dialog-body">

        <form [formGroup]="formGroup">

            <!-- Chart title -->
            <div class="field-block">
                <label class="field-label">Chart title
                    <span class="field-label-hint">— optional, shown top-centre</span>
                </label>
                <mat-form-field appearance="outline" class="full-width">
                    <input matInput [formControl]="titleControl" maxlength="80"
                           placeholder="e.g. Apple 2026 Harvest Window">
                    <mat-hint align="end">{{ titleControl.value?.length || 0 }}/80</mat-hint>
                </mat-form-field>
            </div>

            <mat-divider class="pv-dialog-divider"></mat-divider>

            <!-- Row: Context + Date characteristics -->
            <div class="two-col">
                <div class="field-block">
                    <label class="field-label">Row context</label>
                    <div class="chip-row">
                        <button type="button" *ngFor="let opt of contextOptions"
                                class="opt-chip"
                                [class.active]="contextControl.value === opt.value"
                                [attr.aria-pressed]="contextControl.value === opt.value"
                                [matTooltip]="opt.description"
                                (click)="contextControl.setValue(opt.value)">
                            <mat-icon class="material-symbols-outlined">{{ opt.icon }}</mat-icon>
                            <span>{{ opt.label }}</span>
                        </button>
                    </div>
                </div>

                <div class="field-block">
                    <label class="field-label">Date characteristics
                        <span class="field-label-hint">— 1 = point, 2 = range</span>
                    </label>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select [formControl]="charIdsControl" multiple placeholder="Select 1–2…">
                            <mat-option>
                                <ngx-mat-select-search
                                    [formControl]="charFilterCtrl"
                                    placeholderLabel="Search…"
                                    noEntriesFoundLabel="No date characteristics found for this filter">
                                </ngx-mat-select-search>
                            </mat-option>
                            <ng-container *ngFor="let group of filteredCharGroups | async">
                                <mat-optgroup [label]="group.label || group.category?.label || group.id">
                                    <mat-option *ngFor="let char of group.data" [value]="char.id">
                                        {{ char.label }}
                                    </mat-option>
                                </mat-optgroup>
                            </ng-container>
                        </mat-select>
                        <mat-error *ngIf="charIdsControl.hasError('required')">Pick at least one date characteristic</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Row: Sort + Axis range -->
            <div class="two-col">
                <div class="field-block">
                    <label class="field-label">Sort rows</label>
                    <div class="chip-row">
                        <button type="button" *ngFor="let opt of sortOptions"
                                class="opt-chip"
                                [class.active]="sortModeControl.value === opt.value"
                                [attr.aria-pressed]="sortModeControl.value === opt.value"
                                (click)="sortModeControl.setValue(opt.value)">
                            <mat-icon class="material-symbols-outlined">{{ opt.icon }}</mat-icon>
                            <span>{{ opt.label }}</span>
                        </button>
                    </div>
                </div>

                <div class="field-block">
                    <label class="field-label">Axis range</label>
                    <div class="chip-row">
                        <button type="button" *ngFor="let opt of viewOptions"
                                class="opt-chip"
                                [class.active]="viewModeControl.value === opt.value"
                                [attr.aria-pressed]="viewModeControl.value === opt.value"
                                (click)="viewModeControl.setValue(opt.value)">
                            <mat-icon class="material-symbols-outlined">{{ opt.icon }}</mat-icon>
                            <span>{{ opt.label }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Axis start -->
            <div class="field-block">
                <label class="field-label">Axis start
                    <span class="field-label-hint">— where the week scale begins</span>
                </label>
                <div class="chip-row">
                    <button type="button" *ngFor="let opt of axisStartOptions"
                            class="opt-chip"
                            [class.active]="axisStartControl.value === opt.value"
                            [attr.aria-pressed]="axisStartControl.value === opt.value"
                            [matTooltip]="opt.description"
                            (click)="axisStartControl.setValue(opt.value)">
                        <mat-icon class="material-symbols-outlined">{{ opt.icon }}</mat-icon>
                        <span>{{ opt.label }}</span>
                    </button>
                </div>
            </div>

        </form>

    </mat-dialog-content>

    <mat-dialog-actions align="end" class="pv-dialog-footer">
        <button mat-stroked-button (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="attempt()">
            <mat-icon>check</mat-icon>
            Apply
        </button>
    </mat-dialog-actions>

  </ng-template>

</ng-container>
